import { MONETARY_ATTRIBUTES_CODES } from '@/vue/constants/attribute-types';

export const labelOptions = [
    { iconClass: 'vrm-custom-widget-form__label--blue', name: '', value: 'blue' },
    { iconClass: 'vrm-custom-widget-form__label--red', name: '', value: 'red' },
    { iconClass: 'vrm-custom-widget-form__label--orange', name: '', value: 'orange' },
    { iconClass: 'vrm-custom-widget-form__label--green', name: '', value: 'green' },
    { iconClass: 'vrm-custom-widget-form__label--black', name: '', value: 'black' },
    { iconClass: 'vrm-custom-widget-form__label--indigo', name: '', value: 'indigo' },
    { iconClass: 'vrm-custom-widget-form__label--magenta', name: '', value: 'magenta' },
];

const formatUnit = (code, unit, installation) => {
    if (!MONETARY_ATTRIBUTES_CODES.find(c => c === code)) return unit;
    return unit.replace('mu', installation.currency.sign);
};

const formatDataAttributes = (idDeviceType, attributes, installation) => {
    return attributes.reduce((accumulator, { description, unit, ...attribute }) => {
        if (idDeviceType !== +attribute.idDeviceType) return accumulator;
        //TODO: improvement; use new formatUnitFactor column of dataAttributes to decide when to use formatWithUnit
        // 1220 = PV Yield Solar Charger Forecast
        // 1538 = PV Yield Solar Charger Forecast v2
        if (attribute.idDataAttribute === 1220 || attribute.idDataAttribute === 1538) {
            unit = 'kWh';
        }
        return [
            ...accumulator,
            {
                name: unit
                    ? description + ' (' + formatUnit(attribute.code, unit, installation) + ')'
                    : description,
                ...attribute,
            },
        ];
    }, []);
};

export const parseDevices = (devices, attributes, installation) => {
    return _.flatMap(devices, device => {
        return _.values(device.instances).map(({ deviceName, instance, customName, ...rest }) => ({
            ...rest,
            productName: customName || deviceName,
            instance,
            dataAttributes: formatDataAttributes(+rest.idDeviceType, attributes, installation),
            name:
                deviceName +
                (customName ? ' - ' + customName : '') +
                (instance && +instance !== 0 ? ' [' + instance + ']' : ''),
        }));
    });
};

export const parseParameters = (parameters, devices) => {
    const parsedParameters = [];
    let missingParameter = false;

    parameters.forEach(parameterData => {
        const parsedParameter = {};

        parsedParameter.device = devices.find(
            device =>
                +device.instance === +parameterData.instance &&
                device.dataAttributes.find(
                    attribute => +attribute.idDataAttribute === +parameterData.idDataAttribute,
                ),
        );

        // Device doesn't exist (anymore)
        if (parsedParameter.device === undefined) {
            missingParameter = true;
            return;
        }

        parsedParameter.dataAttribute = parsedParameter.device.dataAttributes.find(
            attribute => +attribute.idDataAttribute === +parameterData.idDataAttribute,
        );

        // Attribute doesn't exist (anymore)
        if (parsedParameter.dataAttribute === undefined) {
            missingParameter = true;
            return;
        }

        parsedParameter.label = labelOptions.find(
            label => label.value === parameterData.serieColor,
        );

        parsedParameter.yAxisProperties = {
            min: parameterData.yAxisMin !== undefined ? parameterData.yAxisMin : null,
            max: parameterData.yAxisMax !== undefined ? parameterData.yAxisMax : null,
            interval:
                parameterData.yAxisInterval !== undefined ? parameterData.yAxisInterval : null,
        };

        parsedParameters.push(parsedParameter);
    });

    return { parsedParameters, missingParameter };
};
